module.exports = __webpack_public_path__ + "img/1576142902.9a3a80ad.jpg";